export default __webpack_public_path__ + "static/media/7S.f91490c5.svg";